import {useFeatureConfig} from "../contexts/FeatureConfigContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import React from "react";
import {Navigate} from "react-router-dom";
import {FeatureKey} from "../models/admin-config.models";

interface FeatureGuardProps {
    featureKey: FeatureKey;
    children: React.ReactNode;
    redirectPath?: string;
}
export const FeatureGuard = ({featureKey, children, redirectPath = '/'}: FeatureGuardProps) => {
    const { isFeatureEnabled, isConfigLoading } = useFeatureConfig();

    if (isConfigLoading) {
        return <LoadingSpinner/>;
    }

    if (!isFeatureEnabled(featureKey)) {
        return <Navigate to={redirectPath} replace />;
    }

    return <>{children}</>;
};